import React, { useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Icon } from 'semantic-ui-react'
import ReactTable from 'react-table'
import { bgVendorRequestEditPath, bgVendorRequestDetailPath, bgVendorRequestCreatePath } from 'routes'
import { ProcurementContainer, ProcurementBody } from 'routes/ProcurementSystem/styled'
import { BGListContainer } from './styled'
import { getBGRequest } from 'ducks/bankGuaranteeRequest'
import { getVendors, getCompanies } from 'ducks/options'
import { columnBgRequest } from '../../AttributeData'
import { MainBodyContent, CustomButton, TablePagination } from 'components'
import SearchList from '../../Form/SearchList'
import CreateBankGuaranteeModal from './Form/CreateModal'

const BankGuaranteeRequest = (props) => {
  const { listBGRequest, valueForm, vendorOptions, companyOptions, user } = props
  const userPageSize = parseInt(localStorage.getItem('userPageSize') || '10')
  const [pageSize, setPageSize] = useState(userPageSize)
  const [showCreateModal, setShowCreateModal] = useState(false)

  React.useEffect(() => {
    window.scrollTo(0, 0)
    props.getBGRequest({ page: 1, size: pageSize })
    
    if (!vendorOptions.data.length && !vendorOptions.loading) {
      props.getVendors()
    }

    if (!companyOptions.data.length && !companyOptions.loading) {
      props.getCompanies()
    }
  }, [])

  return (
    <MainBodyContent headerTitle='Bank Guarantee Request Change / Return'
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          <CustomButton
            onClick={() => props.history.push(bgVendorRequestCreatePath) /*setShowCreateModal(true)*/}
            icon='plus'
            btnColor='gray'
            title='Create' />
        </div>
      }
    >
      <ProcurementContainer>
        <ProcurementBody>
          <SearchList 
            placeholder='Doc No., Title' 
            fetchAPI={props.getBGRequest} 
            formSearchName='formSearchBGRequest' 
            filterDate 
            filterStatus 
            hideProject={true}
            bgType='request'
            pageSize={userPageSize}
          />
          <BGListContainer>
            <ReactTable
              data={listBGRequest.data ? listBGRequest.data : []}
              columns={columnBgRequest(vendorOptions.data, companyOptions.data)}
              defaultPageSize={userPageSize}
              noDataText='No bank guarantee request data.'
              previousText={<Icon name='arrow alternate circle left' />}
              nextText={<Icon name='arrow alternate circle right' />}
              className='-striped -highlight'

              PaginationComponent={TablePagination}
              pages={listBGRequest.totalPage ? listBGRequest.totalPage : 0}
              currentPage={listBGRequest.page ? listBGRequest.page : 0}
              onPageChange={(pageIndex) => {
                props.getBGRequest({ ...valueForm, page: pageIndex + 1, size: pageSize })
              }}
              onPageSizeChange={(pageSize, pageIndex) => {
                setPageSize(pageSize)
                localStorage.setItem('userPageSize', pageSize)
                props.getBGRequest({ ...valueForm, page: pageIndex + 1, size: pageSize })
              }}

              getTdProps={(state, rowInfo, column, instance) => {
                return {
                  onClick: (e, handleOriginal) => {
                    if (rowInfo && column && column.Header !== '') {
                      if ([0, 5,10,11].indexOf(Number(rowInfo.original.status)) >= 0) {
                        window.open(bgVendorRequestEditPath(rowInfo.original.id), '_blank')
                      } else {
                        window.open(bgVendorRequestDetailPath(rowInfo.original.id), '_blank')
                      }
                    }
                    if (handleOriginal) {
                      handleOriginal()
                    }
                  },
                }
              }}
            />
          </BGListContainer>
        </ProcurementBody>
      </ProcurementContainer>
      {
        showCreateModal ? <CreateBankGuaranteeModal closeForm={() => setShowCreateModal(false)} history={props.history} /> : null
      }
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => {
  const user = state.authen.user || {}
  return ({
    user,
    valueForm: getFormValues('formSearchBGRequest')(state),
    listBGRequest: state.bgRequest.listBGRequest.data,
    vendorOptions: state.options.vendors,
    companyOptions: state.options.companies
  })
}

const mapDispatchToProps = {
  getBGRequest,
  getVendors, 
  getCompanies
}

const BankGuaranteeRequestForm = reduxForm({
  form: 'formSearchBGRequest',
  enableReinitialize: true,
})(BankGuaranteeRequest)

export default connect(mapStateToProps, mapDispatchToProps)(BankGuaranteeRequestForm)